import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GenericService } from 'src/app/services/generic.service';
import { append, patch, removeItem, updateItem } from '@ngxs/store/operators';
import { CandidatePersonalDetailsAction } from './candidate-personal-details.action';
import { ICandidatePersonalDetailsTab } from './candidate-personal-details.interface';
import { GenericActions } from '../../generic.actions';
@State<any>({
	name: 'CandidatePersonalDetailsState',
	defaults: {
		personalInfo: {},
		addresses: [],
		workInfo: {},
		socialMediaLinks: [],
		status: ''
	}
})
@Injectable()
export class CandidatePersonalDetailsState {
	private genericService = inject(GenericService);
	private nzMessage = inject(NzMessageService);
	private store = inject(Store);

	@Selector()
	static getPersonalDetailsTab(state: any) {
		return state;
	}

	@Action(CandidatePersonalDetailsAction.GetPersonalDetailsTab)
	getPersonalDetailsTab(context: StateContext<any>) {
		this.genericService
			.get(`ApplicantProtected/GetBasicInfo`)
			.subscribe((data) => {
				context.setState(
					patch<any>({
						personalInfo: data.personalInfo,
						addresses: data.addresses,
						workInfo: data.workInfo,
						socialMediaLinks: data.socialMediaLinks,
						status: data.cloudstaffInfo?.status
					})
				);
			});
	}

	@Action(CandidatePersonalDetailsAction.UpdatePersonalDetails)
	updatePersonalDetails(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.UpdatePersonalDetails
	) {
		context.setState(
			patch<any>({
				personalInfo: action.payload
			})
		);
		this.store.dispatch(new GenericActions.GetProfileCompletion());
	}

	@Action(CandidatePersonalDetailsAction.UpdateAddress)
	updateAddress(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.UpdateAddress
	) {
		context.setState(
			patch<any>({
				addresses: action.payload
			})
		);
		this.store.dispatch(new GenericActions.GetProfileCompletion());
	}

	@Action(CandidatePersonalDetailsAction.SaveSocialMedia)
	saveSocialMedia(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.SaveSocialMedia
	) {
		const id = this.nzMessage.loading('Saving.', {
			nzDuration: 0
		}).messageId;
		this.genericService
			.post(`ApplicantProtected/SaveSocialMedia`, action.payload)
			.subscribe({
				next: (data: any) => {
					this.nzMessage.remove(id);
					this.nzMessage.success('Your changes have been saved.');
					if (action.payload.id === 0) {
						context.setState(
							patch<any>({
								socialMediaLinks: append([data])
							})
						);
					} else {
						context.setState(
							patch<any>({
								socialMediaLinks: updateItem<any>(
									(item) => item.id === data.id,
									action.payload
								)
							})
						);
					}
				},
				error: () => {
					this.nzMessage.remove(id);
					this.nzMessage.error('Error saving.');
				},
				complete: () => {
					this.nzMessage.remove(id);
				}
			});
	}

	@Action(CandidatePersonalDetailsAction.DeleteSocialMedia)
	deleteSocialMedia(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.DeleteSocialMedia
	) {
		const id = this.nzMessage.loading('Deleting...', {
			nzDuration: 0
		}).messageId;
		this.genericService
			.deleteWithBody(
				'ApplicantProtected/DeleteSocialMediaLink',
				action.payload
			)
			.subscribe(() => {
				this.nzMessage.remove(id);
				this.nzMessage.success('Deleted successfully.');
				context.setState(
					patch<any>({
						socialMediaLinks: removeItem<any>(
							(item) => item.id === action.payload.id
						)
					})
				);
			});
	}

	@Action(CandidatePersonalDetailsAction.SaveWorkInfo)
	saveWorkInfo(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.SaveWorkInfo
	) {
		const id = this.nzMessage.loading('Saving...', {
			nzDuration: 0
		}).messageId;
		this.genericService
			.post(`ApplicantProtected/SaveWorkInfo`, action.payload)
			.subscribe(() => {
				this.nzMessage.remove(id);
				this.nzMessage.success('Your changes have been saved.');
				context.setState(
					patch<any>({
						workInfo: action.payload
					})
				);
				this.store.dispatch(new GenericActions.GetProfileCompletion());
			});
	}

	@Action(CandidatePersonalDetailsAction.UpdateProfileImage)
	updateProfileImage(
		context: StateContext<any>,
		action: CandidatePersonalDetailsAction.UpdateProfileImage
	) {
		let tempPersonalInfo = context.getState().personalInfo;

		tempPersonalInfo.imageUrl = action.image;

		context.setState(
			patch<any>({
				personalInfo: tempPersonalInfo
			})
		);
	}

	@Action(CandidatePersonalDetailsAction.SyncStatus)
	syncStatus(context: StateContext<any>) {
		this.genericService
			.get(`ApplicantProtected/SyncJxStatusDetails`)
			.subscribe((data: string) => {
				context.setState(
					patch<any>({
						status: data
					})
				);
			});
	}
}
